import { render, staticRenderFns } from "./_addPriceTierModal.vue?vue&type=template&id=0a68e8b1"
import script from "./_addPriceTierModal.vue?vue&type=script&lang=js"
export * from "./_addPriceTierModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports